import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { IQitafVerifyOtpPayload } from '../../../entity/interface/iEntitlements';

export interface IQitafVerifyOtpUseCase {
    execute(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafVerifyOtpPayload,
        apiToken: { [key: string]: string },
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any>;
}

export class QitafVerifyOtpUseCase implements IQitafVerifyOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafVerifyOtpPayload,
        apiToken: { [key: string]: string },
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any> {
        return await this.subscriptionRepository.qitafVerifyOtp(subType, language, payload, apiToken);
    }
}
